import React from 'react'
import { Breadcrumb } from 'antd'

const BreadcrumbName = ({breadcrumbItems}) => {
	return (
		<>
		 <Breadcrumb separator='/' style={{padding:'0 0 25px 0'}}>
			{
				breadcrumbItems.map(item=> {
					return <Breadcrumb.Item key={item.id}>{item.name}</Breadcrumb.Item>
				})
			}
		</Breadcrumb>
		</>

	)
}

export default BreadcrumbName

